import { colord } from 'colord';
import type { DesignTokenType } from 'common/design-tokens';

const DIMENSION = /^(-?\d*\.?\d+)[a-z%]+$/i;

/** Short, scannable form of a resolved token value for the Inspector value pill; units are left to the tooltip */
export function formatTokenDisplayValue(type: DesignTokenType, value: string | number): string {
	const text = String(value).trim();

	if (type === 'color') {
		const color = colord(text);
		if (!color.isValid()) return text;
		const hex = color.toHex().slice(1, 7).toUpperCase();
		const alpha = color.alpha();
		return alpha < 1 ? `${hex} ${Math.round(alpha * 100)}%` : hex;
	}

	if (type === 'fontFamily') {
		return text
			.split(',')[0]
			.trim()
			.replace(/^['"]|['"]$/g, '');
	}

	return text.match(DIMENSION)?.[1] ?? text;
}
